// extracted by mini-css-extract-plugin
var _1 = "Product_boostCrown__XXRtw";
var _2 = "Product_closeButton__58pc9";
var _3 = "Product_closeIcon__TjuhI fontawesome_min_far__yZwJE fontawesome_min_fa-times__LbGn0";
var _4 = "Product_container__-LWxM";
var _5 = "Product_faLockAlt__+44Pk fontawesome_min_fa-lock-alt__xoCuD";
var _6 = "Product_faLockOpenAlt__-xNlM fontawesome_min_fa-lock-open-alt__sLoBF";
var _7 = "Product_faTimes__IXi+R fontawesome_min_fa-times__LbGn0";
var _8 = "Product_fal__6jUfP fa-light_min_fal__ABekM fontawesome_min_fal__-+-vD";
var _9 = "Product_far__HnhDq fontawesome_min_far__yZwJE";
var _a = "Product_imageAnchor__QEJ0p";
var _b = "Product_imageContainer__LcNLF";
var _c = "Product_info__LrbH2";
var _d = "Product_infoContainer__czjRY";
var _e = "Product_linkContainer__Tpw11";
var _f = "Product_lockedIcon__x8BbZ fontawesome_min_fal__-+-vD fontawesome_min_fa-lock-alt__xoCuD";
var _10 = "Product_modalContent__xZr+T";
var _11 = "Product_modalLink__1VYPE";
var _12 = "Product_name__VIlE-";
var _13 = "Product_price__8bEZM";
var _14 = "Product_question__HQ1PS";
var _15 = "Product_replacementTag__kT+yT";
var _16 = "Product_selectText__64A3+";
var _17 = "Product_thumbnail__XnAox";
var _18 = "Product_unlockedIcon__13YmG fontawesome_min_fal__-+-vD fontawesome_min_fa-lock-open-alt__sLoBF";
export { _1 as "boostCrown", _2 as "closeButton", _3 as "closeIcon", _4 as "container", _5 as "faLockAlt", _6 as "faLockOpenAlt", _7 as "faTimes", _8 as "fal", _9 as "far", _a as "imageAnchor", _b as "imageContainer", _c as "info", _d as "infoContainer", _e as "linkContainer", _f as "lockedIcon", _10 as "modalContent", _11 as "modalLink", _12 as "name", _13 as "price", _14 as "question", _15 as "replacementTag", _16 as "selectText", _17 as "thumbnail", _18 as "unlockedIcon" }
